import { camelizeKeys } from "humps";
import { ActionIcon } from "PFComponents/action_icon";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { Avatar, ProfileBasicInformation } from "PFTypes";
import React from "react";

import css from "./profile_pill.module.scss";

type ProfilePillProps = {
  profile: ProfileBasicInformation;
  handleRemove: VoidFunction;
};

export const ProfilePill = ({ profile, handleRemove }: ProfilePillProps) => {
  const camelizedProfile = camelizeKeys(profile) as ProfileBasicInformation;
  const username = getProfileName(camelizedProfile);

  return (
    <div className={css.profilePill}>
      <img
        className={css.avatar}
        src={(camelizedProfile.avatar as Avatar).thumbnailUrl}
        alt={username}
        title={username}
      />
      <Typography variant="labelRegular" tag="span">
        {username}
      </Typography>
      {handleRemove && (
        <ActionIcon
          name="cross"
          classes={{ root: css.closeIcon }}
          onClick={handleRemove}
          size="sm"
          disableHover
        />
      )}
    </div>
  );
};
